import { I18n } from '@calendly/i18n'
import { AlertIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorIconSecondary, colorTextSecondary } from '@calendly/ui/theme'

import { useEventType } from 'features/event_type_provider'
import { snakeize } from 'services/string_utils'

const getSummary = ({
  workflows,
  eventType: {
    notification_type: notificationType,
    custom_notifications: {
      invitee_reminder: emailReminders,
      invitee_sms_reminder: textReminders,
      invitee_email_follow_up: emailFollowUp,
    } = {}
  } = {}
}) => {
  let summary = I18n.t('publisher.event_type_editor.sections.communications.calendar_invitations')

  if (notificationType === 'email') {
    summary = I18n.t('publisher.event_type_editor.sections.communications.email_confirmations')
  }

  const enabledNotifications = []

  if (emailReminders?.enabled && textReminders?.enabled) {
    enabledNotifications.push(I18n.t('publisher.event_type_editor.sections.communications.summary.email_text_reminders'))
  } else if (emailReminders?.enabled) {
    enabledNotifications.push(I18n.t('publisher.event_type_editor.sections.communications.email_reminders.title'))
  } else if (textReminders?.enabled) {
    enabledNotifications.push(I18n.t('publisher.event_type_editor.sections.communications.text_reminders.title'))
  }

  if (emailFollowUp?.enabled) {
    enabledNotifications.push(I18n.t('publisher.event_type_editor.sections.communications.email_follow_up.title'))
  }

  if (workflows.length) {
    enabledNotifications.push(I18n.t('publisher.event_type_editor.sections.communications.summary.workflows', {
      count: workflows.length
    }))
  }

  if (enabledNotifications.length > 0) {
    summary += ` + ${enabledNotifications[0]}`

    if (enabledNotifications.length > 1) {
      //  enabledNotifications already has a section for workflows so workflowsCount is really workflows.length - 1
      const workflowsCount = workflows.length ? workflows.length - 1 : 0
      const totalCount = (enabledNotifications.length - 1) + workflowsCount
      summary += ` + ${I18n.t('publisher.event_type_editor.sections.more_options.notifications.count', { count: totalCount })}`
    }
  }

  return summary
}

export const Summary = ({ workflows }) => {
  const eventType = useEventType()

  return (
    <BodyText color={colorTextSecondary} size="medium">
      <AlertIcon size="standard" color={colorIconSecondary} spacingRight="8" />
      {getSummary({
        eventType: snakeize(eventType),
        workflows: snakeize(workflows)
      })}
    </BodyText>
  )
}
